export default __webpack_public_path__ + "static/resume_6_1_26-575b3917798a425049c82c1f07171518.pdf";